import { render, staticRenderFns } from "./commonFooter.vue?vue&type=template&id=1d152a48&scoped=true&"
import script from "./commonFooter.vue?vue&type=script&lang=js&"
export * from "./commonFooter.vue?vue&type=script&lang=js&"
import style0 from "./commonFooter.vue?vue&type=style&index=0&id=1d152a48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d152a48",
  null
  
)

export default component.exports